<template>
  <p class="p-0 m-0">
    {{ negative ? '-' : '' }}{{ new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'narrowSymbol',
    }).format(Math.abs(numericAmount)) }}
    <span
      v-if="!hideCurrencyCode"
      :class="['inline', currencyCodeClass]"
    >
      {{ currencyCode }}
    </span>
  </p>
</template>

<script>
export default {
  name: 'Price',
  props: {
    amount: {
      type: [Number, String],
      required: true
    },
    currencyCode: {
      type: String,
      default: 'USD'
    },
    currencyCodeClass: {
      type: String,
      default: ''
    },
    hideCurrencyCode: {
      type: Boolean,
      default: true
    },
    negative: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    numericAmount () {
      if (typeof this.amount === 'number') return this.amount
      if (typeof this.amount === 'string') {
        let s = this.amount.trim()
        if (!s) return 0
        const hasComma = s.includes(',')
        const hasDot = s.includes('.')
        if (hasComma && hasDot) {
          // Decide decimal by the last separator
          const lastComma = s.lastIndexOf(',')
          const lastDot = s.lastIndexOf('.')
          if (lastComma > lastDot) {
            // European style: 1.234,56 -> 1234.56
            s = s.replace(/\./g, '').replace(',', '.')
          } else {
            // US style: 1,234.56 -> 1234.56
            s = s.replace(/,/g, '')
          }
        } else if (hasComma && !hasDot) {
          // 1234,56 -> 1234.56
          s = s.replace(/\./g, '').replace(',', '.')
        } else {
          // 1234.56 or 1234
          s = s.replace(/,/g, '')
        }
        s = s.replace(/[^0-9.-]/g, '')
        const n = Number(s)
        return Number.isFinite(n) ? n : 0
      }
      return 0
    }
  }
}
</script>